// Reference:
// https://nicobachner.com/sveltekit-theme-switch
// https://github.com/picocss/pico/blob/f9e97c0bf430df8fa3f730eb6a6e84f63d4a9b0c/docs/js/src/theme-switcher.js

export enum Theme {
  // Use preferred mode from system
  Auto = 'auto',
  Light = 'light',
  Dark = 'dark',
}

const storageKey = 'theme';

let current = $state<Theme>(Theme.Auto);

export const theme = {
  get value() {
    return current;
  },
};

// No `browser` guard: setTheme is only ever called from client code paths (onMount,
// UI event handlers, and test-only init). Callers take responsibility for not invoking
// it during SSR; tests run under jsdom where document + localStorage exist.
export function setTheme(value: Theme) {
  current = value;
  if (value === Theme.Auto) {
    delete document.documentElement.dataset['theme'];
    document.documentElement.style.colorScheme = '';
  } else {
    document.documentElement.dataset['theme'] = value;
    document.documentElement.style.colorScheme = value;
  }
  localStorage[storageKey] = value;
}

/** Read the persisted theme (if any) from localStorage and apply it. Call during client
 * bootstrap (onMount). No-op when no valid value is persisted. */
export function loadPersistedTheme() {
  const saved = localStorage[storageKey];
  if (saved === Theme.Auto || saved === Theme.Light || saved === Theme.Dark) {
    setTheme(saved);
  }
}
